<template lang="pug">
b-modal#updatePaymentOptionStatus(
  ref="updatePaymentOptionStatus"
  :title="$t('ui.combine.change_payment_mode_status')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
  @hidden="onClose"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.bank')").mb-0
      //- DebounceInput(
      //-   size="sm"
      //-   ref="bank_id"
      //-   required
      //-   type="text"
      //-   :dirty="$v.bank_id.$dirty"
      //-   :error="$v.bank_id.$error"
      //-   v-model.trim.lazy="$v.bank_id.$model"
      //-   :disabled="loading"
      //- )
      //- ValidateResult(:value="$v.bank_id" :name="$t('ui.bank_id')")
      BankListGateway(
        ref="bank"
        size="sm"
        required
        type="array"
        :dirty="$v.bank.$dirty"
        :error="$v.bank.$error"
        v-model.trim.lazy="$v.bank.$model"
        :disabled="loading"
        :fullList=false
      )
      ValidateResult(:value="$v.bank" :name="$tc('ui.banks', 1)")
    //- b-form-group(:label="$t('ui.bank_acc_no')").mb-0
    //-   DebounceInput(
    //-     size="sm"
    //-     ref="bank_acc_no"
    //-     required
    //-     type="text"
    //-     :dirty="$v.bank_acc_no.$dirty"
    //-     :error="$v.bank_acc_no.$error"
    //-     v-model.trim.lazy="$v.bank_acc_no.$model"
    //-     :disabled="loading"
    //-   )
    //-   ValidateResult(:value="$v.bank_acc_no" :name="$t('ui.bank_acc_no')") 
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, email, sameAs, numeric, helpers } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import BankListGateway from "@/library/BankListGateway";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    BankListGateway
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      payment_mode: "",
      // bank_id: "",
      bank: "",
      // bank_acc_no: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: { 
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
  },
  validations: {
    bank: {
      required
    },
    // bank_acc_no: {
    //   required
    // }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.paymentOptionUpdateStatusUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          payment_mode: this.payment_mode,
          new_status: true,
          bank_id: this.bank.split(' - ')[0].trim(),
          bank_acc_no: this.bank.split(' - ')[1].trim()
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.updatePaymentOptionStatus.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "change_payment_mode_status", this.feedback.status);
                  this.$refs.updatePaymentOptionStatus.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.bank_id = "";
      // this.bank_acc_no = ""
      this.payment_mode = ""
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      if(this.item.bank_id != null)
        this.bank = this.item.bank_id + ' - ' + this.item.bank_name;
      else
        this.bank = ''
      this.payment_mode = this.item.payment_mode;
      this.$refs.bank.$el.focus();
      var vm = this;
      $(document).ready(function() {
        vm.$v.$reset();
      });
    },
    onClose: function() {
      this.$emit("clicked", true);
    }
  }
};
</script>
